<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <page-header />
    </el-header>
    <el-container style="height: calc(100% - 60px)">
      <!-- 侧边栏 -->
      <el-aside :style="{width: asideWidth + 'px'}">
        <page-aside />
      </el-aside>
      <!-- 主体区域 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import pageHeader from '@/components/PageHeader'
import pageAside from '@/components/PageAside'
export default {
  components: {
    'page-header': pageHeader,
    'page-aside': pageAside
  },
  data () {
    return {
      asideWidth: this.$store.state.asideWidth
    }
  },
  watch: {
    '$store.state.asideWidth' (newVal) {
      this.asideWidth = newVal
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}

.el-aside {
  height: 100%;
  overflow: hidden;
}
.el-main {
  background-color: #eff2f9;
}
</style>